import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import type { MessageRequestApi } from '@/modules/messaging/types';
import { invalidateQuery } from '@/utils/queries';

interface UpdateMessageParams {
  threadId: string;
  messageId: string;
  message: MessageRequestApi;
}

export const useUpdateMessageMutation = () => {
  return useMutation({
    mutationFn: async ({
      threadId,
      messageId,
      message,
    }: UpdateMessageParams) => {
      const { data } = await fetchClient.PUT(endpoints.threadMessage, {
        params: {
          path: {
            threadId,
            id: messageId,
          },
        },
        body: message,
      });
      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { threadId } = variables;

      invalidateQuery(messagingQueryKeys.threads())();
      invalidateQuery(messagingQueryKeys.thread(threadId))();
    },
  });
};
